import React, { useState } from 'react';

import { Form } from '@dashboard/components/Formik';
import useProduct from '../useProduct';

const ProductDescriptionForm = () => {
  const { product, updateProduct } = useProduct();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Form
      initialValues={{
        description: product.description,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updateProduct.mutateAsync(values);

        actions.resetForm({
          values: {
            description: data.description,
          },
        });

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'description',
          type: 'rich-text',
          placeholder: "Add info about what you're selling",
          onLoading: setIsLoading,
        },
      ]}
      submitButton={{
        label: 'Save',
        disabled: isLoading,
      }}
    />
  );
};

export default ProductDescriptionForm;
